export default "__VITE_ASSET__f9ff5e7a__"